/* eslint-disable */
import React from 'react'
import { Form, FormSpy } from 'react-final-form'

import WizardSlider from '@piconetworks/wizard-slider'

import getFields from 'apps/lib/getFields'
import observers from 'apps/lib/observers'

import ConditionAggregator from '@piconetworks/condition-aggregator'

import WizardRedux from 'common/pkgs/WizardRedux'
import xFrame from 'common/xFrame'

import RedeemGift from './RedeemGift'
import { useDispatch } from 'react-redux'

const RedeemGiftIndex = (props) => {
    const dispatch = useDispatch()
    //const fields = getFields(fieldsFromResponse)

    return (
        <WizardSlider
            backButton={false}
            
        >
            <WizardRedux.Step
                onSubmit={({ values }) => {
                    const submitWizard = values?.wizardData?.submitWizard

                    if (!submitWizard) {
                        throw new Error('submitWizard not selected')
                    }

                    return {
                        submitWizard,
                    }
                }}
                rffProps={{
                    mutators: {
                        setWizardData: (args, state, utils) => {
                            console.log('args', args)
                            utils.changeValue(state, 'wizardData', () => args[0])
                        },
                    },
                }}
                render={({
                    form,
                }) => (
                    <ConditionAggregator
                        Submit={() => null}
                        onSubmit={async (e, data) => {
                            console.log('data', data.payloads?.redeemGift?.thankYouText)
                            
                            // if (!data.state.customFields.isComplete) {
                            //     throw new Error('finish custom fields')
                            // }

                            await observers.awaitGiftResults()

                            xFrame.prompt.showThankYou({
                                thankYouText: data.payloads?.redeemGift?.thankYouText || 'Your gift has been redeemed successfully.',
                                dispatch,
                            })
                        }}
                        postSubmit={(data) => {
                            console.log('postSubmit', data)

                            // advance to the next wizard step
                            // form.mutators.setWizardData(data.submitResults)

                            // form.submit()
                        }}
                        conditions={{
                            redeemGift: {
                                required: false,
                                isComplete: false,
                                preSubmit: async (data) => {
                                    // const payload = data.payload(data.state, 'redeemGift')
                                    console.log('preSubmit redeemGift', data.payloads.redeemGift)
                                },
                                Component: ({ changeCompletionStatus, conditionAggregatorState }) => {
                                    return (
                                        <RedeemGift
                                            {...props}
                                            canSubmit={true}
                                            // canSubmit={conditionAggregatorState?.customFields?.isComplete}
                                            submissionSuccess={({ thankYouText }) => {
                                                changeCompletionStatus({
                                                    isComplete: true,
                                                    thankYouText,
                                                })
                                            }}
                                            canSubmitError={() => {
                                                console.log('canSubmitError')
                                            }}
                                        />
                                    )
                                },
                            },
                            // customFields: {
                            //     required: true,
                            //     isComplete: false,
                            //     preSubmit: async (data) => {
                            //         console.log('preSubmit customFields', data)
                            //     },
                            //     Component: ({ changeCompletionStatus }) => (
                            //         <Form
                            //             onSubmit={() => {}}
                            //             render={({ errors }) => (
                            //                 <form>
                            //                     <FormSpy
                            //                         onChange={(props) => {
                            //                             const hasSubmitValues = Object.keys(props?.values).length
                            //                             const formIsValid = props.valid && Object.keys(errors || {}).length === 0

                            //                             if (
                            //                                 !hasSubmitValues 
                            //                                 || !formIsValid
                            //                             ) {
                            //                                 return
                            //                             }


                            //                             changeCompletionStatus({
                            //                                 isComplete: true,
                            //                                 ...props?.values,
                            //                             })
                            //                         }}
                            //                     />
                            //                     {fields.map((Field, idx) => (
                            //                         <Field
                            //                             key={idx}
                            //                         />
                            //                     ))}
                            //                 </form>
                            //             )}
                            //         />
                            //     ),
                            // },
                        }}
                    />
                )}
            />
        </WizardSlider>
    )
}

export default RedeemGiftIndex

